import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* getBatchMessageTemplate({ payload: { signal, id, onSuccess } }) {
  try {
    const { data } = yield call(fetch, { api: api.sendbird.templates.get, id, signal });

    onSuccess && onSuccess(data.result);
    yield put(actions.getBatchMessageTemplateDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getBatchMessageTemplateFailed,
      endpoint: api.sendbird.templates.get.url
    });
  }
}

function* updateBatchMessageTemplate({ payload: { id, values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.sendbird.templates.update, id, data: values });

    onSuccess && onSuccess(data.result);
    yield put(actions.updateBatchMessageTemplateDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.updateBatchMessageTemplateFailed,
      handledErrors,
      endpoint: api.sendbird.templates.update.url
    });
  }
}

export const getBatchMessageTemplateSaga = takeEvery(types.GET_BATCH_MESSAGE_TEMPLATE_REQUEST, getBatchMessageTemplate);
export const updateBatchMessageTemplateSaga = takeEvery(types.UPDATE_BATCH_MESSAGE_TEMPLATE_REQUEST, updateBatchMessageTemplate);